import React, {useEffect, useMemo, useState} from 'react';
import Layout from '../Shared/Layout';
import {
    CircularProgress,
    Container,
    Grid,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core";
import styled from "styled-components";
import { Inertia } from '@inertiajs/inertia'

import FormPage from "../Shared/FormPage";
import {InertiaLink, useForm} from "@inertiajs/inertia-react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import TextField from "@material-ui/core/TextField";
import StatusFlow from "../Shared/StatusFlow/StatusFlow";
import MuiButton from "@material-ui/core/Button";
import FormField from "../Shared/FormField";
import {Button} from "../Shared/Button";
import {Field, Form as FinalForm} from "react-final-form";
import TextInput from "../Shared/TextInput";
import Select from "../Shared/Select";
import BackButton from "../Shared/BackButton";
import {getCookieValue} from "../utils/getCookieValue";
import DateSelect from "../Shared/DateSelect";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MuiSelect from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import timezones from 'timezones-list';
import { Trans } from "../utils/i18n";
import {InputAdornment, Tooltip} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import TabBar from "../Shared/TabBar";
import {useMutation} from "@tanstack/react-query";

const Wrapper = styled.div`
`;


const ButtonWrapper = styled.div`
  margin-top: 30px;
`;

export default function Setup2Fa({ user, qrCode, success, warning, }) {
    const { data, setData, post, processing, errors } = useForm({
        '2fa_code': '',
    });
    const confirmTwoFactorMutation = useMutation({
        mutationFn: newTodo => axios.post(route('2fa.confirmTwoFactor'), newTodo),
    });

    const handleSubmit = async e => {
        e.preventDefault();
        confirmTwoFactorMutation.mutate(data, {
            onSuccess: () => {

            },
            onError: () => {

            },
        });
    }

    if(confirmTwoFactorMutation.data?.data?.success || success) {
        return (
            <Wrapper>
                <Container maxWidth="md">
                    <BackButton/>
                    <h1><Trans i18nKey={'profile.setup2Fa'}>Setup Two Factor Authentication</Trans></h1>
                    <TabBar tabs={[
                        { label: 'Settings', name: 'profile', current: false },
                        { label: 'Two Factor Authentication', name: 'profile.2fa', current: true },
                    ]}/>

                    <p>
                        <Trans i18nKey={'profile.setup2Fa.success'}>You have successfully integrated Two Factor Authentication to your B2X account.</Trans>
                    </p>
                    <p>
                        <Trans i18nKey={'profile.setup2Fa.success2'}>After each login you will be asked for the 2FA credentials coming from your "Authenticator" app.</Trans>
                    </p>
                    <p>
                        <Trans i18nKey={'profile.setup2Fa.success3'}>
                            Please keep in mind that due to security reasons, you can not disable the 2FA process from this backend.
                            If you have an important reason to resign from 2FA please contact your B2X account manager.
                        </Trans>
                    </p>
                </Container>
            </Wrapper>
        )
    }

    return (
        <Wrapper>
            <Container maxWidth="md">
                <BackButton/>
                <h1><Trans i18nKey={'profile.setup2Fa'}>Setup Two Factor Authentication</Trans></h1>
                <TabBar tabs={[
                    { label: 'Settings', name: 'profile', current: false },
                    { label: 'Two Factor Authentication', name: 'profile.2fa', current: true },
                ]}/>

                {
                    warning &&
                    <Alert severity="warning">
                        { warning }
                    </Alert>
                }

                <p>
                    Welcome to the Two-Factor Authentication (2FA) setup!
                </p>

                <p>
                    To enhance the security of your account, we highly recommend enabling 2FA, which provides an extra layer of protection by requiring you to verify your identity with an additional code generated by an authenticator app.
                </p>

                <p>
                    Please follow these simple steps to set up 2FA:
                </p>

                <p>
                    Install an authenticator app: If you haven't already, download a trusted authenticator app such as Google Authenticator or Authy from your mobile device's app store.
                </p>

                <p>
                    Scan the QR code: Open your authenticator app and use it to scan the QR code displayed on this screen.
                </p>


                <div dangerouslySetInnerHTML={{ __html: qrCode }} />

                <p>
                    Verify the setup: After scanning the QR code, the authenticator app will generate a 6-digit code. Enter this code in the field below within the next 30 seconds to confirm the setup.
                </p>

                <form onSubmit={handleSubmit}>
                    <TextField
                        id="2fa_code"
                        label={<Trans i18nKey="login.2fa_code">Two Factor Code</Trans>}
                        name="2fa_code"
                        value={data['2fa_code']}
                        type="number"
                        required
                        error={!!confirmTwoFactorMutation.data?.data?.error}
                        helperText={confirmTwoFactorMutation.data?.data?.error}
                        variant="filled"
                        style={{ marginBottom: '25px' }}
                        onChange={(e) => setData('2fa_code', e.target.value)}
                    />

                    <ButtonWrapper>
                        <MuiButton type="submit" variant="contained" color="secondary">
                            {
                                !confirmTwoFactorMutation.isLoading && <Trans i18nKey="profile.save">Save</Trans>
                            }
                            {
                                confirmTwoFactorMutation.isLoading && <CircularProgress style={{ height: 28, width: 28 }}/>
                            }
                        </MuiButton>
                    </ButtonWrapper>
                    {
                        errors && errors.email && <p>{ errors.email }</p>
                    }
                    {
                        errors && errors.password && <p>{ errors.password }</p>
                    }
                </form>

                <p>
                    Once you've successfully completed these steps, you'll be prompted to enter a 6-digit code generated by your authenticator app every time you log in to your account. This additional security measure will make it much harder for unauthorized users to access your account, even if they have your password.
                </p>
            </Container>
        </Wrapper>
    )
}

Setup2Fa.layout = page => <Layout children={page} />;
